<template>
    <div @click.stop v-show="isOpen()">
        <div class="fixed top:0 left:0 w:full h:full z:$(comment-overlay-zindex) bg:#253F5F40 func-panel-overlay" @click.stop="hide"></div>
        <div class="fixed bottom:66 left:0 top:auto right:0 w:full mt:21 z:$(comment-zindex) {bottom:66}.no-marq" :class="{ 'no-marq': !toggler('marq').isOpen() }">
            <div class="rel bg:white r:0 rt:20 flex max-height:calc(90dvh-66px) flex-direction:column {max-height:calc(90dvh-66px)}.no-marq" :class="{ 'no-marq': !toggler('marq').isOpen() }">
                <div class="h:72 p:16|24 pt:24 rel bg:white rt:20 border-bottom:1|solid|#CECECE flex ai:center jc:space-between color:#5E6472 func-panel-header">
                    <div class="abs top:8 left:50% translateX(-50%) w:48 h:4 r:2 bg:#CECECE"></div>
                    <div class="f:20 font-weight:700" v-text="label"></div>
                    <button class="round bg:#F8F8F8 p:8 {bg:#eaeaea}:hover" @click.stop="hide()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M12.484 4.70615C12.8746 4.31553 12.8746 3.68115 12.484 3.29053C12.0934 2.8999 11.459 2.8999 11.0684 3.29053L7.77773 6.58428L4.48398 3.29365C4.09336 2.90303 3.45898 2.90303 3.06836 3.29365C2.67773 3.68428 2.67773 4.31865 3.06836 4.70928L6.36211 7.9999L3.07148 11.2937C2.68086 11.6843 2.68086 12.3187 3.07148 12.7093C3.46211 13.0999 4.09648 13.0999 4.48711 12.7093L7.77773 9.41553L11.0715 12.7062C11.4621 13.0968 12.0965 13.0968 12.4871 12.7062C12.8777 12.3155 12.8777 11.6812 12.4871 11.2905L9.19336 7.9999L12.484 4.70615Z" fill="#5E6472" />
                        </svg>
                    </button>
                </div>
                <slot name="body"></slot>
            </div>
        </div>
    </div>
</template>

<script setup>
    const sign = Symbol("FuncPanel");
    const toggleStore = ToggleStore();

    const emit = defineEmits(["hidden", "shown"]);

    const hide = () => {
        toggler(sign).close();
        emit("hidden");
    }

    const isOpen = () => {
        return toggler(sign).isOpen();
    }

    const show = () => {
        toggler(sign).open();
        emit("shown");
    }

    const toggler = (name) => {
        return toggleStore.toggler(name);
    };

    defineExpose({ hide, isOpen, show });

    defineProps({
        label: { type: String }
    });
</script>
